import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../models/qfilter.model';
import { SearchToolbarFactoryParameters, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
  selector: 'app-customers-summary',
  templateUrl: './customers-summary.component.html',
  styleUrls: ['./customers-summary.component.css']
})
export class CustomersSummaryComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  customersLoyaltyTrend: LoyaltyChart;
  newCustomersChart: LoyaltyChart;

  public data: QFilterModel;

  public get filterApplied(): boolean
  {
    return this.data != null;
  }

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.translate.get([
      'loyalty_chart.fatturato',
      'loyalty_chart.penetrazioneCarta',
      'loyalty_chart.nuovi_clienti',
      'customer_chart.customers_loyalty_trend',
      'loyalty_chart.period',
      'loyalty_chart.periodo_commerciale',
      'customer_chart.customers'
    ]).subscribe((t) => {
      this.translations = {
        fatturato: t['loyalty_chart.fatturato'],
        penetrazioneCarta: t['loyalty_chart.penetrazioneCarta'],
        new_customers: t['loyalty_chart.nuovi_clienti'],
        customers_loyalty_trend: t['customer_chart.customers_loyalty_trend'],
        etichetta_periodo: t['loyalty_chart.period'],
        etichetta_periodo_commerciale: t['loyalty_chart.periodo_commerciale'],
        etichetta_clienti: t['customer_chart.customers']
      };
    });

    this.initCharts();
  }

  initCharts() {
    this.customersLoyaltyTrend = (new LoyaltyChart('line'));
    this.customersLoyaltyTrend.options.plotOptions = { column: { stacking: 'normal' } };
    this.customersLoyaltyTrend.options.xAxis.title.text = this.translations.etichetta_periodo;
    this.customersLoyaltyTrend.options.yAxis.title.text = this.translations.etichetta_clienti;
    this.newCustomersChart = new LoyaltyChart('line');
    this.newCustomersChart.options.xAxis.title.text = this.translations.etichetta_periodo_commerciale;
    this.newCustomersChart.options.yAxis.title.text = this.translations.etichetta_clienti;
  }

  ngOnInit() {
    let searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
    searchParams.svcAnalytics = this.svcAnalytics;
    searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist];

    this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
      this.searchModel = model;
    });
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.iscritti_loyalty',
      'indicator.raggiungibilita_clienti',
      'indicator.clienti_profilabili',
      'indicator.clienti_target',
    ]).subscribe(indTransl => {
      this.indicators = [];
      this.indicatorService.indicatorCalculation('Q037', this.data).subscribe((res) => {

        this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'iscritti_loyalty')], {dynamic: true}, indTransl));
        this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'raggiungibilita_clienti')], {decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, indTransl));
        this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'clienti_profilabili')], {unit_period_prec: '%'}, indTransl));
        this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'clienti_target')], {unit_period_prec: '%'}, indTransl));

      });
    });

/*
    // [P Vecchio grafic
    this.indicatorService.getChart('Q041', this.data, true ).subscribe(resp => {
       const res = resp.series;
      this.chartsService.loadChartBase(this.customersLoyaltyTrend, res[0], [res[2], res[4], res[6], res[8], res[10]], this.translate);
    });
*/
    this.chartsService.loadChart(this.customersLoyaltyTrend, 'Q041', data, this.indicatorService, null, true);

    this.chartsService.loadChart(this.newCustomersChart, 'Q042', data, this.indicatorService, this.translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-summary/customers-summary.component.ts